import React from "react"
import { Route } from "react-router-dom"
import { ModalSwitch } from "../Modal"
import ConfirmModal from "./ConfirmModal"
import AdminView from "./AdminView"

const Admin = ({ networkAvailable, ...props }) =>
  <ModalSwitch
    {...props}
    ModalRoutes={[
      <Route
        key="confirmDelete"
        path="/admin/:type/:id/confirm/:action"
        component={ConfirmModal}
      />,
      <Route
        key="confirmDeleteWithParent"
        path="/admin/:type/:parentId/:id/confirm/:action"
        component={ConfirmModal}
      />
    ]}
  >
    <Route component={AdminView} />
  </ModalSwitch>

export default Admin



// WEBPACK FOOTER //
// ./src/Admin/index.js